(function () {
  function initStickyAtc() {
    var stickyBar = document.getElementById("sticky-atc-bar");
    if (!stickyBar) return;

    // Find the main product add-to-cart button (Dawn-style)
    var mainBtn = document.querySelector(".product-form__submit");
    var footer = document.querySelector("footer");
    if (!mainBtn) return;

    var isMainBtnPast = false;
    var isFooterVisible = false;

    function updateBarVisibility() {
      if (isMainBtnPast && !isFooterVisible) {
        stickyBar.classList.add("sticky-atc-visible");
        stickyBar.classList.remove("sticky-atc-hidden");
      } else {
        stickyBar.classList.add("sticky-atc-hidden");
        stickyBar.classList.remove("sticky-atc-visible");
      }
    }

    // Observe main button
    var mainBtnObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        isMainBtnPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        updateBarVisibility();
      });
    }, { threshold: 0 });

    mainBtnObserver.observe(mainBtn);

    // Observe footer
    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isFooterVisible = entry.isIntersecting;
          updateBarVisibility();
        });
      }, { threshold: 0 });

      footerObserver.observe(footer);
    }

    // Sync variant IDs
    var stickyInput = document.getElementById("sticky-variant-id");
    var mainInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');

    if (mainInput && stickyInput) {
      var variantObserver = new MutationObserver(function () {
        stickyInput.value = mainInput.value;
      });
      variantObserver.observe(mainInput, { attributes: true });
    }
  }

  // Delay init a bit to avoid competing with LCP
  window.addEventListener("load", function () {
    setTimeout(initStickyAtc, 1200);
  });
})();